import styled from 'styled-components';

export const DocBalloonToolbarRef = styled.div`
  > div {
    /* To fix the non-click issue from the library */
    pointer-events: all !important;
    z-index: var(--zindex-popover);
  }
`;
